/**
 * Decorative layers (the desktop key-art backdrop, canvas motes) are mounted only after the first screen is on screen and the page is
 * idle (incident 9.9.2026: on iPhone Safari the very first frame after boot blocked the main thread for 23–29 s before the app could even
 * issue its first request; the boot frame now paints the app alone). On a phone the fitted stage covers the viewport and these layers are
 * invisible behind the opaque plates, so nothing of this — backdrop image, loop or motes — is fetched there at all.
 */
import { render } from 'preact';
import { Backdrop } from './ui/Backdrop';
import { initFx } from './fx/particles';
/** room beside the stage (the same media query as the stylesheet's --scale rule): only then is a backdrop visible */
const stageFloating = () => matchMedia('(min-aspect-ratio: 1005 / 1672)').matches;
import { mark } from './boot-trace';

const idle = (fn: () => void) => ('requestIdleCallback' in window ? (window as unknown as { requestIdleCallback: (cb: () => void, o?: { timeout: number }) => void }).requestIdleCallback(fn, { timeout: 2000 }) : setTimeout(fn, 500));
let done = false;
export function mountDecor(): void {
  if (done) return; done = true;
  idle(() => {
    mark('decor');
    if (!stageFloating()) { mark('decor-skip'); return; } // phone: the stage fills the screen, so the backdrop would only load to sit under it
    const root = document.getElementById('backdrop-root'); if (root) render(<Backdrop />, root);
    const canvas = document.getElementById('stage') as HTMLCanvasElement | null;
    if (canvas) { try { initFx(canvas); } catch (e) { console.warn('fx layer unavailable', e); canvas.style.display = 'none'; } }
    mark('decor-done');
  });
}
